import { useMutation } from "react-query";

import { SaveDnmRoleMappingsIProps } from "~/entity/DnmRoleMappings/model/schema";

import { useDnmRoleMappings } from "./useDnmRoleMappings";

interface MutateOptions {
  onSuccess?: (data?: any) => void;
  onError?: (error: any) => void;
}

interface DataIProps {
  data: SaveDnmRoleMappingsIProps;
  options?: MutateOptions;
}

export const useSaveDnmRoleMappings = () => {
  const { saveRoleMappings } = useDnmRoleMappings();

  const mutation = useMutation({
    mutationFn: async (props: DataIProps) => {
      const result = await saveRoleMappings(props.data);
      if (result.data) {
        return result.data;
      } else {
        throw new Error("Не удалось сохранить запись");
      }
    },
    onSuccess: (data, { options }) => {
      options?.onSuccess?.(data);
    },
    onError: (error, { options }) => {
      options?.onError?.(error);
    },
  });

  const save = (data: SaveDnmRoleMappingsIProps, options?: MutateOptions) => {
    mutation.mutate({ data, options });
  };

  return { save };
};
